import { useEffect, useState } from 'react';

import { ApplePayButtonStatus } from 'constants/';

import { isApplePayJsAvailable } from '../utils';

const useApplePayAvailability = () => {
  const [applePayButtonStatus, setApplePayButtonStatus] = useState(ApplePayButtonStatus.UNKNOWN);

  useEffect(() => {
    const checkApplePayAvailability = async () => {
      try {
        const canMakePayments = await isApplePayJsAvailable();
        setApplePayButtonStatus(
          canMakePayments ? ApplePayButtonStatus.AVAILABLE : ApplePayButtonStatus.NOT_AVAILABLE,
        );
      } catch (error) {
        setApplePayButtonStatus(ApplePayButtonStatus.NOT_AVAILABLE);
      }
    };

    checkApplePayAvailability();
  }, []);

  return applePayButtonStatus;
};

export { useApplePayAvailability };
